import { createUseStyles, ComposedTheme } from '@glu/theming';

const styles = ({ spacing: { unit } }: ComposedTheme) => ({
  footer: {
    fontSize: '10px',
    margin: [unit * 2.5, unit * 4, 0],
    padding: [0, 3]
  },
  footerContent: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: [2 * unit, 0]
  },
  fdicImg: {
    display: 'block',
    marginRight: unit * 2,
    maxHeight: 30,
    maxWidth: '20%'
  }
});

export default createUseStyles(styles);
